import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, Effect } from '@ngrx/effects';


import * as vieweractions from '../viewer/viewer.actions';


@Injectable()
export class ViewerEffects {

    constructor(
        private actions$: Actions
    ) { }

    

}
